export enum AllowedLanguages {
  En = "en",
  Fr = "fr",
  Nl = "nl",
}

export enum AllowedJobSearchParams {
  City = "city",
  ContractType = "type",
  Job = "related",
  Language = "language",
  Lat = "lat",
  Lng = "lng",
  MaxDistance = "max_distance",
  Niche = "speciality",
  Office = "o",
  Page = "page",
  Query = "query",
  Regime = "regime",
  Sector = "sector_group",
  functionGroup = "function_group",
}

export enum AllowedBlogOverviewSearchParams {
  BlogCategories = "blog_categories",
  Language = "language",
  Page = "page",
}

export enum AllowedOfficeSearchParams {
  City = "city",
  Lat = "lat",
  Lng = "lng",
  MaxDistance = "max_distance",
  Niche = "speciality",
  Page = "page",
}

export enum AvailableTargetAudience {
  EMPLOYEE = "EMPLOYEE",
  EMPLOYER = "EMPLOYER",
}

export interface TranslatedPath {
  language: AllowedLanguages;
  url: string;
}

export interface StandardPageProps {
  params: Promise<{
    locale: AllowedLanguages;
    path: string[];
  }>;
  searchParams: Promise<Record<string, string>>;
}

export interface SearchHistoryEntry {
  city?: string;
  max_distance?: string;
  query?: string;
}

export interface FilterValue {
  count?: number;
  value: string;
}

export interface FilterType {
  name: string;
  values: FilterValue[];
}

export interface PathObject {
  en: string;
  fr: string;
  nl: string;
}

export enum AllowedFaqOverviewSearchParams {
  Language = "language",
  Page = "page",
  Search = "search",
  TargetAudience = "target_audience",
}

export enum AllowedFaqCategoryOverviewSearchParams {
  CategoryUUID = "category_uuid",
  Language = "language",
  Page = "page",
}

export interface UserInfoCookie {
  birthDate: string;
  email: string;
  firstName: string;
  lastName: string;
  postalCode: string;
  telephone: string;
}

export interface WorkIdJobApplicationCookie {
  jobId?: string;
  locale: AllowedLanguages;
  officeKey?: string;
  source?: string;
  type?: string;
}

export interface TempUserFromSocialCookie {
  email: string;
  id: string;
  name: string; // full name (first + last)
  provider: string; // "linkedin" | "facebook" | "workid"
}
